import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFlex,{staticClass:"pa-4",attrs:{"xs12":"","sm12":""}},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzonefile","options":_vm.options},on:{"vdropzone-complete":_vm.onUploadComplete,"vdropzone-sending":_vm.onUploadStart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }